import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/auth/authentication.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

    constructor(private authService: AuthenticationService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.authService.logout().subscribe(() => {
            this.router.navigateByUrl('login');
        }, () => {
            this.router.navigateByUrl('login');
        });
    }

}
